import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './http.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { ProcessHubService } from './aplication/api/Services/Process.hub.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
   declarations: [
        AppComponent, NotfoundComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        LottieComponent,
        AppRoutingModule,
        AppLayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })],
        providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        TranslateService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        ProcessHubService,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideLottieOptions({
            player: () => import('lottie-web'),
          }),

    ] })
export class AppModule { }
